/* eslint-disable-next-line import/no-relative-packages */
import { Environment } from '../../../config';

const environment = process.env.BUILD_ENV as Environment;

/**
 * Get the current environment.
 */
export const getEnvironment = (): Environment => {
  return Object.values(Environment).includes(environment)
    ? environment
    : Environment.DEV;
};
